import React, { useContext ,useEffect, useState} from 'react'
import { Context } from "../context/Context"
// import { hadesData, hadithData } from "../Database/Database";
import { useLocation, useParams, Link } from "react-router-dom";
import { SendGuiDataEvents } from '../lib/CommonScript';

export default function Hades() {
    const { lang, handleShowLoader } = useContext(Context);
    const { id } = useParams();
    const [hadithData , setHadithData] = useState()


    // handle previous path
    useEffect(() =>{
        localStorage.setItem("prevPath","hades_list");
    },[])


    // const months = hadithData.month

    useEffect(() => {
        handleShowLoader(true)
        const postData = async () => {
          try {
            const response = await fetch('https://is-apis.bngrenew.com/ongoing_orangeIC/api/hadithContent', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
            //   body: JSON.stringify({ key: 'value' }),
            });

            if (!response.ok) {
              throw new Error('Network response was not ok');
            }

            // Process the response here
            const data = await response.json();
            // console.log("hades data --> ", data);
            setHadithData(data)
            handleShowLoader(false)
          } catch (error) {
            console.error('Error:', error);
            handleShowLoader(false)
          }
        };

        postData();
      }, []);


      useEffect(() => {
        //send gui events
        let guiDataEvent = {};
        guiDataEvent["w_action"] = "card_click";
        guiDataEvent["name"] = "hadith";
        SendGuiDataEvents(guiDataEvent);
      }, []);




    return (
        <div className='min-h-screen pt-20 h-full max-width bg-bgGreenIslam text-black '>
            <div className='overflow-y-auto w-5/6  mx-auto  mt-20'>
                {
                    hadithData && hadithData.month.map((element, ind) => {

                        return (
                            <div key={element.id} className='px-20 bg-green-200 h-10 mb-4 rounded-2xl'>
                                <Link
                                to={{
                                    pathname : '/hadesList/' + element.id,
                                    state: {
                                        // audios: hadithData[`content${element.id}`]
                                        audios: hadithData[`content${element.id}`],
                                    }

                                }}

                                >
                                    <p dir="rtl" className="py-2">{element.month}</p>
                                </Link>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
